const FastWay_conf = {
  title: '',
  itemPrefix: 'AnforaStoreBackend'
};

export default FastWay_conf;
